/*
 * 机器生成，不要手改。改动请编辑 scripts/make_case_assets.py 后重跑：
 *   python3.11 scripts/make_case_assets.py
 *
 * 来源：Asterove_yeoui 仓库里 5 次真实运行的产物，只复制与转码，不改画面。
 * kind=chain 的「处理前」是同一段提示词复读到第 4 代的脏图，「处理后」是走完整管线
 * （参考级净化 → 以净化图为唯一垫图重生成 → 无损格子切除）的成品；
 * kind=source 的「处理前」是用户自己的原图。
 *
 * 读数不在这里：三项指标与验收结论已不进前端（2026-09-09 用户裁决），
 * 它们改由生成脚本把关——验收未过、读数口径不可比、成品小到镜片放不大，
 * 三种情况都直接报错，不会悄悄出成一条案例。
 */
import type { CaseSample } from '../types'

export const CASES: CaseSample[] = [
  {
    "id": "N",
    "title": "夜景长发",
    "kind": "source",
    "model": "Image 2.5",
    "before": {
      "src": "/cases/n_before.jpg",
      "pixels": [
        1579,
        996
      ]
    },
    "after": {
      "src": "/cases/n_after.jpg",
      "pixels": [
        1520,
        960
      ]
    },
    "hotspot": [
      0.25,
      0.7
    ],
    "provenance": {
      "run": "e29_night_notch",
      "sourceSha": "",
      "diagFiles": [
        "e26_image25_night_rawref_constrained_v1.png",
        "e29_image25_night_plateref_constrained_v1_notch.png"
      ],
      "verifyFile": "e29_image25_repair_report.json",
      "boardFile": "night_directional_wide_scale_native_audit_v4.json",
      "beforeReport": "e26_image25_hair_decisive_report.json"
    }
  },
  {
    "id": "H25",
    "title": "苔藓峡谷",
    "kind": "chain",
    "model": "Image 2.5",
    "before": {
      "src": "/cases/h25_before.jpg",
      "pixels": [
        1672,
        941
      ]
    },
    "after": {
      "src": "/cases/h25_after.jpg",
      "pixels": [
        1665,
        937
      ]
    },
    "hotspot": [
      0.45,
      0.3556
    ],
    "provenance": {
      "run": "run_e30_H25_gen4_regen_20260909",
      "sourceSha": "d882eb77b2c256ec",
      "diagFiles": [
        "e23_image25_chainH_gen4_v1_input_diag.json",
        "e23_image25_chainH_gen4_v1_regen1__restored_diag.json"
      ],
      "verifyFile": "e23_image25_chainH_gen4_v1_regen1__restored_verify.json"
    }
  },
  {
    "id": "H",
    "title": "苔藓峡谷",
    "kind": "chain",
    "model": "Image 2.0",
    "before": {
      "src": "/cases/h_before.jpg",
      "pixels": [
        1280,
        720
      ]
    },
    "after": {
      "src": "/cases/h_after.jpg",
      "pixels": [
        1672,
        941
      ]
    },
    "hotspot": [
      0.4,
      0.3556
    ],
    "provenance": {
      "run": "run_e13_H_gen4_regen_20260906",
      "sourceSha": "6f4a3040cdf953b9",
      "diagFiles": [
        "alice_chainH_moments_repeat_gen4_v1_miyang_input_diag.json",
        "alice_chainH_moments_repeat_gen4_v1_miyang_restored_diag.json"
      ],
      "verifyFile": "alice_chainH_moments_repeat_gen4_v1_miyang_verify.json"
    }
  },
  {
    "id": "F",
    "title": "雨林小径",
    "kind": "chain",
    "model": "Image 2.0",
    "before": {
      "src": "/cases/f_before.jpg",
      "pixels": [
        1672,
        941
      ]
    },
    "after": {
      "src": "/cases/f_after.jpg",
      "pixels": [
        1665,
        937
      ]
    },
    "hotspot": [
      0.5,
      0.6222
    ],
    "provenance": {
      "run": "run_e13_F_gen4_regen_20260906",
      "sourceSha": "e343409c84442d69",
      "diagFiles": [
        "alice_chainF_moments_repeat_gen4_v1_miyang_input_diag_canon.json",
        "alice_chainF_moments_repeat_gen4_v1_miyang_restored_diag.json"
      ],
      "verifyFile": "alice_chainF_moments_repeat_gen4_v1_miyang_verify.json"
    }
  },
  {
    "id": "K",
    "title": "冰柱洞窟",
    "kind": "chain",
    "model": "Image 2.0",
    "before": {
      "src": "/cases/k_before.jpg",
      "pixels": [
        1672,
        941
      ]
    },
    "after": {
      "src": "/cases/k_after.jpg",
      "pixels": [
        1665,
        937
      ]
    },
    "hotspot": [
      0.4,
      0.8
    ],
    "provenance": {
      "run": "run_e20_K_gen4_regen_20260907",
      "sourceSha": "4d77c2694864b526",
      "diagFiles": [
        "alice_chainK_moments_repeat_gen4_v1_miyang_input_diag.json",
        "alice_chainK_moments_repeat_gen4_v1_miyang_restored_diag.json"
      ],
      "verifyFile": "alice_chainK_moments_repeat_gen4_v1_miyang_verify.json"
    }
  }
]
